/**
 *   Created by FANGlh on 2018/11/23 18:03.
 *   Desc:审批主界面
 */

import React, {Component} from 'react';
import './Approvel.css';
import Swiper from 'swiper/dist/js/swiper';
import 'swiper/dist/css/swiper.min.css';
import ApprovelItem from './ApprovelItem';
import {Link} from 'react-router-dom';
import ReactDOM from 'react-dom';
import {fetchPost, fetchGet, fetchGetNoSession} from '../../../utils/fetchRequest';
import {API} from '../../../configs/api.config';
import InfiniteScroll from 'react-infinite-scroller'
import LoadingMore from "../../../components/LoadingMore";
import {Toast} from 'antd-mobile';
import {connect} from 'react-redux';
import RefreshLayout from "../../../components/RefreshLayout";
import {Skeleton, List} from 'antd';
import {getIntValue, getStrValue, isObjEmpty} from "../../../utils/common";
import {saveListState} from "../../../redux/actions/listState";
import nodata_img from '../../../style/imgs/no_data.png';
let myApplypageIndex = 0;
let myApprovepageIndex = 0;
const mPageSize = 10

class Approvel extends Component {
    constructor() {
        super();
        this.state = {
            selectIndex: 0,
            hasMoreData: true,
            applyList: [],
            approvelList: [],
            isMyApplyRefreshing: false,
            isMyApproveRefreshing: false,
            isMyapplydload: true,
            isMyapprovedload: true,
            height: document.documentElement.clientHeight,
        }
    }

    componentWillMount() {
        document.title = '我的审批'
    }

    componentDidMount() {
        const that = this
        const hei = this.state.height - ReactDOM.findDOMNode(this.contain).offsetTop;
        this.setState({
            height: hei
        })
      this.mySwiper = new Swiper('.swiper-container', {
            autoplay: false,
            loop: false,
            on: {
                slideChangeTransitionEnd: function () {
                    that.setState({
                        selectIndex: this.activeIndex
                    })
                }
            }
        })
        console.log('listState', this.props.listState)
        if (this.props.listState.tabIndex >= 0) {
            this.setState({
                selectIndex: this.props.listState.tabIndex
            },function () {
                this.mySwiper.slideTo(this.state.selectIndex, 0, false)
            })
        }
        if (this.props.listState && !isObjEmpty(this.props.listState.listData)) {
            console.log('11111')
            this.setState({
                applyList: this.props.listState.listData,
                isMyapplydload: false,
            }, () => {
                ReactDOM.findDOMNode(this.myApplyTab).scrollTop = this.props.listState.scrollTop
            })
            myApplypageIndex = this.props.listState.pageIndex
        } else {
            console.log('22222')
            myApplypageIndex = 0;
            this.getMyApplyData();
            Toast.hide();
        }

        if (this.props.listState && !isObjEmpty(this.props.listState.listData2)) {
            this.setState({
                approvelList: this.props.listState.listData2,
                isMyapprovedload: false,
            }, () => {
                ReactDOM.findDOMNode(this.myApproveTab).scrollTop = this.props.listState.scrollTop2
            })
            myApprovepageIndex = this.props.listState.pageIndex2
        } else {
            myApprovepageIndex = 0;
            this.getMyApproveData();
            Toast.hide();
        }

    }


    render() {
        const isMyapplyItems =
            <RefreshLayout
                ref={el => {
                    this.myApplyTab = el
                }}
                refreshing={this.state.isMyApplyRefreshing}
                onRefresh={this.getMyApplyData}
                height={this.state.height}>
                <Skeleton loading={this.state.isMyapplyding} active paragraph={{rows: 3}}>
                    {
                        this.state.applyList.length > 0 ?
                        this.state.applyList.map((itemdata,index) =>
                            <ApprovelItem itemdata={itemdata} isMyApply={true}   index={index} onItemClick={this.onItemClick.bind(this)}/>
                        ) :
                            <List dataSource={this.state.applyList}
                                  renderItem={(applyListBean,index) => (
                                      <List.Item>
                                          <ApprovelItem itemdata={applyListBean} isMyApply={true}   index={index} onItemClick={this.onItemClick.bind(this)}/>
                                      </List.Item>
                                  )}/>
                    }

                </Skeleton>
            </RefreshLayout>

        const isMyapproveItems =
            <RefreshLayout
                ref={el => {
                    this.myApproveTab = el
                }}
                refreshing={this.state.isMyApproveRefreshing}
                onRefresh={this.getMyApproveData}
                height={this.state.height}>
                <Skeleton loading={this.state.isMyapprovedload} active paragraph={{rows: 3}}>
                    {
                        this.state.approvelList.length > 0 ?
                        this.state.approvelList.map((itemdata,index) =>
                            <ApprovelItem itemdata={itemdata}isMyApply={false}  index={index} onItemClick={this.onItemClick.bind(this)}/>
                        ) :
                        <List dataSource={this.state.approvelList}
                        renderItem={(approvelListBean,index) => (
                        <List.Item>
                            <ApprovelItem itemdata={approvelListBean} isMyApply={false}  index={index} onItemClick={this.onItemClick.bind(this)}/>
                        </List.Item>
                    )}/>
                    }

                </Skeleton>
            </RefreshLayout>

        return (
            <div className='phone-select-root'>
                <div className='gray-line'></div>
                <div className='identity-select'>
                    <div className={this.state.selectIndex == 0 ?
                        'identity-item-select' : 'identity-item-normal'}
                         onClick={this.onMyApplyClick}>我的申请
                    </div>
                    <div className={this.state.selectIndex == 1 ?
                        'identity-item-select' : 'identity-item-normal'}
                         onClick={this.onMyApprovelClick}>我的审批
                    </div>
                </div>
                <div className="swiper-container" style={{backgroundColor: "#F2F2F2", height: "100vh"}}
                     ref={el => {
                         this.contain = el
                     }}>
                    <div className="swiper-wrapper">
                        <div className="swiper-slide" >
                            {
                                this.state.applyList.length > 0 ? isMyapplyItems
                                    :
                                    <div className="no_data"><img src={nodata_img} alt="" style={{width:'100%',height:'100%'}}/></div>
                            }
                        </div>
                        <div className="swiper-slide">
                            {
                                this.state.approvelList.length > 0 ? isMyapproveItems
                                    :
                                    <div className="no_data"><img src={nodata_img} alt=""
                                                                  style={{width: '100%', height: 'auto'}}/></div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    onItemClick = (isMyApply,index) => {
        console.log('onItemClick-index',index)
        this.saveListStatus(false, index)
    }


    saveListStatus = (pageLimit, itemIndex) => {
        const {applyList, approvelList} = this.state
        let applyScroll = 0, approvelScroll = 0, applyIndex = 0, approveleIndex = 0

        if (applyList.length <= 10 && pageLimit) {
            applyList.length = 0
            applyIndex = 0
            applyScroll = 0
        } else if(applyList.length > 10){
            applyIndex = myApplypageIndex
            applyScroll = ReactDOM.findDOMNode(this.myApplyTab).scrollTop
        }
        if (approvelList.length <= 10 && pageLimit) {
            approvelList.length = 0
            approveleIndex = 0
            approvelScroll = 0
        } else if (approvelList.length > 10){
            approveleIndex = myApprovepageIndex
            approvelScroll = ReactDOM.findDOMNode(this.myApproveTab).scrollTop
        }
        saveListState({
            scrollTop: applyScroll,
            listData: applyList,
            pageIndex: applyIndex,
            tabIndex: this.state.selectIndex,
            scrollTop2: approvelScroll,
            listData2: approvelList,
            pageIndex2: approveleIndex,
            itemIndex: itemIndex
        })()
    }
    getMyApplyData = () => {
        myApplypageIndex++
        try {
            this.setState({
                isMyApplyRefreshing: true
            })
        } catch (e) {

        }

        fetchGet(API.oaApproveList, {
            teacherId: this.props.userInfo.user.userFunId,
            pageIndex: myApplypageIndex,
            pageSize: mPageSize
        }, {}).then((response) => {
            if (response.success && response.data) {
                if (myApplypageIndex == 1) {
                    this.setState({
                        applyList: response.data.proposes,
                    })
                } else if(response.data.proposes.length > 0 && response.data.proposes != []){
                    var applyList = this.state.applyList
                    response.data.proposes.forEach((itemdata,index) =>{
                        applyList.push(itemdata)
                    },() =>{
                        this.setState({
                            applyList: applyList,
                        })
                    })
                    console.log("applyList.length",applyList.length)
                }
                console.log("applyList",this.state.applyList)
                console.log("myApplypageIndex",myApplypageIndex)
            }
            this.setState({
                isMyApplyRefreshing: false,
                isMyapplydload: false,
            })
        }).catch((error) => {
            console.log('error',error)
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
            this.setState({
                isMyApplyRefreshing: false,
                isMyapplydload: false,
            })
        })
    }

    getMyApproveData = () => {
        myApprovepageIndex++
        try {
            this.setState({
                isMyApproveRefreshing: true
            })
        } catch (e) {

        }
        // Toast.loading("获取数据中...", 0)
        // Toast.hide()
        fetchGet(API.oaApproveList, {
            teacherId: this.props.userInfo.user.userFunId,
            pageIndex: myApprovepageIndex,
            pageSize: mPageSize
        }, {}).then((response) => {
            if (response.success && response.data) {
                if (myApprovepageIndex == 1) {
                    this.setState({
                        approvelList: response.data.approves
                    })
                } else if(response.data.approves.length > 0){
                    var approvelList = this.state.approvelList
                    response.data.proposes.forEach((itemdata,index) =>{
                        approvelList.push(itemdata)
                    },() =>{
                        this.setState({
                            approvelList: approvelList,
                        })
                    })
                    console.log("approvelList.length",approvelList.length)
                }
                console.log("approvelList",this.state.approvelList)
            }
            this.setState({
                isMyApproveRefreshing: false,
                isMyapprovedload: false,
            })

        }).catch((error) => {
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
            this.setState({
                isMyApproveRefreshing: false,
                isMyapprovedload: false,
            })
        })
    }
    clickApplyItem = (itemdata) => {
        console.log('clickApplyItem', itemdata)
    }
    clickApprovelItem = (itemdata) => {
        console.log('clickApprovelItem', itemdata)
    }
    onMyApplyClick = () => {
        this.setState({
            selectIndex: 0
        }, () => {
            this.mySwiper.slideTo(this.state.selectIndex, 300, false)
        })
    }

    onMyApprovelClick = () => {
        this.setState({
            selectIndex: 1
        }, () => {
            this.mySwiper.slideTo(this.state.selectIndex, 300, false)
        })
    }

    componentWillReceiveProps(newProps) {
    }

    shouldComponentUpdate(newProps, newState) {
        return true;
    }

    componentWillUpdate(nextProps, nextState) {
    }

    componentDidUpdate(prevProps, prevState) {
    }

    componentWillUnmount() {
    }
}

let mapStateToProps = (state) => ({
    listState: {...state.redListState},
    userInfo: {...state.redUserInfo}
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Approvel)
